
module.exports =  require('./lib/');



/*****************
 ** WEBPACK FOOTER
 ** ./~/engine.io-client/index.js
 ** module id = 168
 ** module chunks = 0
 **/